var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87514 9.02C8.87303 10.7557 8.37197 11.6236 7.69708 11.8746C7.24737 12.0418 6.75251 12.0418 6.3028 11.8746C5.62791 11.6236 5.12685 10.7557 4.12474 9.02L2.08091 5.48C1.0788 3.74428 0.57774 2.87642 0.697821 2.16646C0.777838 1.69337 1.02527 1.26482 1.39496 0.958974C1.94977 0.5 2.95189 0.5 4.95612 0.5L9.04377 0.500001C11.048 0.500001 12.0501 0.500001 12.6049 0.958975C12.9746 1.26482 13.222 1.69337 13.3021 2.16646C13.4221 2.87642 12.9211 3.74428 11.919 5.48L9.87514 9.02Z",
    fill: "#98A1C0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.e050062cde6fa1ed9984003b8a80116d.svg";
export { ForwardRef as ReactComponent };